module.exports = __webpack_public_path__ + "img/act_pro_img23s_03.854d3eee.png";